import request from "@/utils/request";

/**
 * 获取用户的数字资产列表
 * @param {Object} params - 查询参数
 * @param {Number} params.assetType - 资产类型（1-全部，2-场景，3-数字藏品）
 */
export const getDigitalAssets = (params) => {
  return request({
    method: "get",
    url: "/user/digital-assets",
    params,
  });
};

/**
 * 获取资产详情
 * @param {Number} id - 资产ID
 */
export const getDigitalAssetDetail = (id) => {
  return request({
    method: "get",
    url: `/user/digital-assets/${id}`,
  });
};

/**
 * 更新区块链信息（上链后调用）
 * @param {Number} id - 资产ID
 * @param {Object} data - 区块链信息
 * @param {String} data.blockchainHash - 区块链哈希
 * @param {String} data.contractAddress - 合约地址
 * @param {String} data.tokenId - Token ID
 */
export const updateBlockchainInfo = (id, data) => {
  return request({
    method: "put",
    url: `/user/digital-assets/${id}/blockchain`,
    data,
  });
};

/**
 * 删除资产
 * @param {Number} id - 资产ID
 */
export const deleteDigitalAsset = (id) => {
  return request({
    method: "delete",
    url: `/user/digital-assets/${id}`,
  });
};
